import api from '../api';

const InventoryService = {
  listItems(params = {}) {
    return api.get('/inventory/items', { params });
  },
  createItem(payload) {
    return api.post('/inventory/items', payload);
  },
  updateItem(id, payload) {
    return api.put(`/inventory/items/${id}`, payload);
  },
  deleteItem(id) {
    return api.delete(`/inventory/items/${id}`);
  },
  listWarehouses(params = {}) {
    return api.get('/inventory/warehouses', { params });
  },
  createWarehouse(payload) {
    return api.post('/inventory/warehouses', payload);
  },
  updateWarehouse(id, payload) {
    return api.put(`/inventory/warehouses/${id}`, payload);
  },
  deleteWarehouse(id) {
    return api.delete(`/inventory/warehouses/${id}`);
  },
  listCategories(params = {}) {
    return api.get('/inventory/categories', { params });
  },
  createCategory(payload) {
    return api.post('/inventory/categories', payload);
  },
  updateCategory(id, payload) {
    return api.put(`/inventory/categories/${id}`, payload);
  },
  deleteCategory(id) {
    return api.delete(`/inventory/categories/${id}`);
  },
  listMovements(params = {}) {
    return api.get('/inventory/movements', { params });
  },
  registerMovement(payload) {
    return api.post('/inventory/movements', payload);
  },
  downloadReport(params = {}) {
    return api.get('/inventory/report', {
      params,
      responseType: 'blob',
    });
  },
};

export default InventoryService;
